import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=78c6887a&scoped=true&"
var script = {}
import style0 from "./Products.vue?vue&type=style&index=0&id=78c6887a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c6887a",
  null
  
)

export default component.exports